import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import {
    QuestionnaireTimestamp,
    questionnaireTimestampNames,
    questionnaireTimestamps
} from "pokal_api"
import { useAppDispatch, useAppSelector } from "../../redux/store/hooks"
import {
    changeMedicationTimestampSelection,
    selectMedicationTimestamp
} from "../../redux/ProfessionalDashboard"

function MedicationTimestampSelection() {
    const selectedTimestamp = useAppSelector(selectMedicationTimestamp)

    const dispatch = useAppDispatch()

    function selectTimestamp(timestamp: QuestionnaireTimestamp) {
        dispatch(changeMedicationTimestampSelection(timestamp))
    }

    return (
        <Card width={"100%"}>
            <div className={"flex flex-col space-y-4"}>
                <SmallHeadingComponent>
                    Erfassungszeitpunkt
                </SmallHeadingComponent>
                <select
                    className={"rounded hidden"}
                    value={selectedTimestamp ?? undefined}
                    onChange={(e) =>
                        selectTimestamp(
                            Number(e.target.value) as QuestionnaireTimestamp
                        )
                    }>
                    {questionnaireTimestamps.map((q) => (
                        <option key={q} value={q}>
                            {questionnaireTimestampNames[q]}
                        </option>
                    ))}
                </select>
                <div className={"flex-1 bg-neutral-500 flex rounded shadow"}>
                    {questionnaireTimestamps.map((q) => (
                        <div
                            onClick={() => selectTimestamp(q)}
                            key={q}
                            className={
                                "flex-1 text-center rounded text-white p-3 " +
                                (selectedTimestamp === q
                                    ? "bg-neutral-800"
                                    : "cursor-pointer hover:bg-neutral-700")
                            }>
                            {questionnaireTimestampNames[q]}
                        </div>
                    ))}
                </div>
            </div>
        </Card>
    )
}

export default MedicationTimestampSelection
